import * as LocalStorage from 'store'

export const enum LocalStorageKey {
  PER_PAGE = 'perPage',
  CONTACT_SORT_VALUE = 'contactSortValue',
  CONTACT_COLUMNS = 'contactColumns',
  DEAL_SORT_VALUE = 'dealSortValue',
  DEAL_COLUMNS = 'dealColumns',
  PROJECT_TIMELINE_ACTIVE = 'projectTimelineActive',
  PROJECT_SORT_VALUE = 'projectSortValue',
  PROJECT_COLUMNS = 'projectColumns',
  LEDGER_ITEM_SORT_VALUE = 'ledgerItemSortValue',
  RECURRING_INVOICE_COLUMNS = 'recurringInvoiceColumns',
  INVOICE_COLUMNS = 'invoiceColumns',
  QUOTATION_COLUMNS = 'quotationColumns',
  INCOMING_SELF_BILLING_ORDER_SORT_VALUE = 'incomingSelfBillingOrderSortValue',
  INCOMING_SELF_BILLING_ORDER_COLUMNS = 'incomingSelfBillingOrderColumns',
  RECURRING_INVOICE_SORT_VALUE = 'recurringInvoiceSortValue',
  EXPENSE_SORT_VALUE = 'expenseSortValue',
  EXPENSE_COLUMNS = 'expenseColumns',
  PRODUCT_SORT_VALUE = 'productSortValue',
  PRODUCT_COLUMNS = 'productColumns',
  TIME_ENTRY_SORT_VALUE = 'timeEntrySortValue',
  BOARD_LABEL_EXPANSION = 'boardLabelExpansion',
  CALENDAR_FILTER = 'calendarFilter',
  BOARD_SORT_VALUE = 'boardSortValue',
  TASK_COLUMNS = 'taskColumns',
  TRACK_VIEW_LAYOUT = 'trackViewLayout',
  TRACK_VIEW_MODE = 'trackViewMode',
  LEDGER_CONDITION_SORT_VALUE = 'ledgerConditionSortValue',
  PROPOSAL_SORT_VALUE = 'proposalSortValue',
  CONTRACT_SORT_VALUE = 'contractSortValue',
  PREFERRED_EXPORT_FORMAT = 'preferredExportFormat',
  BANK_ACCOUNT_SORT_VALUE = 'bankAccountSortValue',
  PAYMENT_SORT_VALUE = 'paymentSortValue',
  TRANSACTION_SORT_VALUE = 'transactionSortValue',
  DOCUMENTS_SORT_VALUE = 'documentsSortValue',
  IMPORT_ENTRIES_GROUP_BY = 'importEntriesGroupBy',
  IMPORT_ENTRIES_CUSTOM_DESCRIPTION = 'importEntriesCustomDescription',
  PLAYBOOK_SORT_VALUE = 'playbookSortValue',
  FILE_SORT_VALUE = 'fileSortValue',
  FORM_SORT_VALUE = 'formSortValue',
  SEQUENCE_SORT_VALUE = 'sequenceSortValue',
  SEQUENCE_COLUMNS = 'sequenceColumns',
  SEQUENCE_ENROLLMENT_SORT_VALUE = 'sequenceEnrollmentSortValue',
  HELP_CENTER_SORT_VALUE = 'helpCenterSortValue',
  NEWS_CENTER_SORT_VALUE = 'newsCenterSortValue',
  WIDGET_SORT_VALUE = 'widgetSortValue',
  CREDIT_NOTE_COLUMNS = 'creditNoteColumns',
  DASHBOARD_MEMO = 'dashboard_memo',
  EVENT_TYPE_SORT_VALUE = 'eventTypeSortValue',
  EVENT_TYPE_COLUMNS = 'eventTypeColumns',
  BOOKING_COLUMNS = 'bookingColumns',
  BOOKING_SORT_VALUE = 'bookingSortValue',
}

export const migrateLocaleStorageValues = () => {
  if (LocalStorage.get(LocalStorageKey.RECURRING_INVOICE_SORT_VALUE) === 'recurring_schedules.next_invoice_on_asc') LocalStorage.set(LocalStorageKey.RECURRING_INVOICE_SORT_VALUE, 'recurring_schedules.next_occurrence_on_asc')
  if (LocalStorage.get(LocalStorageKey.RECURRING_INVOICE_SORT_VALUE) === 'recurring_schedules.next_invoice_on_desc') LocalStorage.set(LocalStorageKey.RECURRING_INVOICE_SORT_VALUE, 'recurring_schedules.next_occurrence_on_desc')
}

export default LocalStorage